import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

export default function DialogContainer(props) {
  const modalRoot = document.getElementById('window_backdrop');
  const { showBackDrop = false } = props;
  const el = React.useMemo(() => document.createElement('div'), []);
  el.id = props.id;

  useEffect(() => {
    if (showBackDrop) {
      el?.classList.add('window-backDrop');
      modalRoot?.appendChild(el);
    }
    return () => {
      document.getElementById(props.id)?.remove();
    };
  }, []);

  return showBackDrop ? (
    ReactDOM.createPortal(props.children, el)
  ) : (
    <>{props.children}</>
  );
}
